import React, { useEffect, useState, useRef } from 'react';
import "../../../css/pages/likedbusinesses.scss";
import { countFormatter } from '../../Helper';
import userLikedImage from "../../../images/map/userLikedImage.png";
import shareGrey from "../../../images/shareGrey.png";
import APICall from '../../actions/apicall';
import Cookies from 'js-cookie';
import Loader from '../reusable/Loader';
import Share from '../popups/ShareEmail';
import { trimCharacters } from '../../Helper';
import SVGImage from '../reusable/SelectIcon';
import { selectCategoryName } from '../../actions/findcategory';

function LikedBusinesses() {
    let accessToken = Cookies.get('access_token') ?? null;
    const toolTipElement = useRef();

    const itemPerPage = 40;
    const [isLoading, setIsLoading] = useState(true);
    const [offSet, setOffSet] = useState(0);
    const [responseData, setResponseData] = useState({});
    const [likedBusinessData, setLikedBusinessData] = useState([]);
    const [loaderPosition, setLoaderPosition] = useState('middle');
    const [selectedBusiness, setSelectedBusiness] = useState([]);
    const [openShare, setOpenShare] = useState(false);
    const [showLikedBusiness, setShowLikedBusiness] = useState(true);
    const [messageText, setMessageText] = useState('No Liked Businesses.');
    const [showCopiedMessage, setShowCopiedMessage] = useState(false);

    const handleUnLikeBusiness = (businessId) => {
        let data = {
            business_id: businessId,
            liked: false
        }
        window.dataLayer.push({'event': 'dislike', 'businessId': businessId});
        let accessToken = Cookies.get('access_token') ?? null;
        APICall.AddBusinessLike(data, accessToken, (response) => {
            setLikedBusinessData([]);
            setOffSet(0);
            handleLikedBusiness();
            setIsLoading(true);
            if (response.status == 200 && response.data.status == 'success' && !(response.data.data.liked)) {
                // setTotalLikeCount(response.data.data.total_likes);
            }
        })
    }

    useEffect(() => {
        if(likedBusinessData && likedBusinessData.length > 0) {
            if(document.querySelector(`.last-card`)) {
                const observer = new IntersectionObserver (entries => {
                    entries.forEach(entry => {
                        if (entry.isIntersecting) {
                            if(responseData.next !== null) {
                                setOffSet(offSet + itemPerPage);
                                setLoaderPosition('bottom');
                                setIsLoading(true);
                                handleLikedBusiness();
                            }
                            observer.unobserve(entry.target);
                            return;
                        }
                    });
                }, {threshold: 0});
                observer.observe(document.querySelector(`.last-card`));
            }
        }
    }, [likedBusinessData])

    const handleShare = (businessData) => {
        if (businessData) {
            (businessData) && setSelectedBusiness(businessData);
            window.dataLayer.push({'event': 'share_click', 'businessId': businessData.id, 'clickedFrom': 'liked_businesses'});
            if (navigator.share) {
                navigator.share({
                    // title: 'RS11',
                    text: `Click here to view RS11’s FREE estimated value of ${businessData.business_name} business in ${businessData.location_address_city} and estimated value of millions of more businesses in the US.`,
                    url: `${window.location.origin}/map?id=${businessData.srno}&type=${(businessData.category == 'Airbnb' ? 1 : 2)}`,
                })

                .then(() => {
                    console.log(response.data.message);
                })
                .catch(error => console.log('Error sharing:', error));        
            }
            else {
                setOpenShare(true);
            }
        }
    }

    const handleCloseShare = (actions) => {
        if (actions == 'copy_link') {
            setShowCopiedMessage(true);
            setTimeout(() => {
                setShowCopiedMessage(false);
            }, 2000);
        }
        setOpenShare(false)
    }

    // useEffect(() => {
    //     // Add event listener to document
    //     document.addEventListener('click', handleClickOutside, true);
    
    //     // Clean up event listener on unmount
    //     return () => {
    //       document.removeEventListener('click', handleClickOutside, true);
    //     };
    // }, []);

    // const handleClickOutside = (event) => {
    //     if (toolTipElement.current && toolTipElement.current.contains(event.target)) {
    //         setOpenShare(false);
    //     }
    // };


    const handleLikedBusiness = () => {
        setShowLikedBusiness(true);
        APICall.GetLikedBusinesses(accessToken, itemPerPage, offSet, (response) => {
            if (response.status == 200 && response.data.status == 'success') {
                setIsLoading(false);
                if (response.data.data.count == 0) {
                    setMessageText('No Liked Businesses.')
                    setShowLikedBusiness(false);
                }
                setLoaderPosition('middle');
                if (response.data.data.previous != null) {
                    setLikedBusinessData(likedBusinessData.concat(response.data.data.results));
                }
                else {
                    setLikedBusinessData(response.data.data.results);
                }
                setResponseData(response.data.data);
            }
            else {
                setMessageText(response.data.message);
                setShowLikedBusiness(false);
            }
        })
    }

    useEffect(() => {
        handleLikedBusiness();
    }, [])

    return (
        <div>
            {(isLoading && loaderPosition == 'middle')? (
                <Loader loader={loaderPosition} />
            ) : (
            (showLikedBusiness) ? (
            <div className='liked-business-container' ref={toolTipElement}> 
                
                {
                    likedBusinessData.map((item, i) => (
                        <div className='card-key' key={i}>
                            {i === likedBusinessData.length - 1 && <div className={`last-card`} />}
                            <div className='business-card'>
                            {
                                (openShare && selectedBusiness == item) && (
                                    <Share url={`${window.location.origin}/map?id=${selectedBusiness.srno}&type=${(selectedBusiness.category == 'Airbnb' ? 1 : 2)}`} businessData={selectedBusiness} closeShare={handleCloseShare} likedBusiness={true} />

                                )
                            }
                            {
                                (showCopiedMessage && selectedBusiness == item) && (
                                <div className='copied-text-like' >Copied to clipboard!</div>)
                            }
                                <div className='card-container'>            
                                    <div className='logo-name-container'>
                                        <div className='business-category-container'>
                                            <SVGImage category={item.category} />
                                            <p>{selectCategoryName(item.category)}</p>
                                        </div>
                                        <div className='name-address-container'>
                                            <p className='business-name-text' title={item.business_name}>{trimCharacters(item.business_name)}</p>
                                            {
                                                (item.full_address) ? (
                                                    <p className='business-address'>{item.full_address}</p>
                                                ) : (
                                                (item.category != 'Airbnb') ? (
                                                    <p className='business-address'>{item.location_address}&nbsp; 
                                                        {item.location_address_city},&nbsp;{item.location_address_state},&nbsp;
                                                        {item.zip_code}</p>) : (
                                                        <p className='business-address'>{item.location_address}</p>
                                                    )
                                                )
                                            }
                                        </div>
                                    </div>
                                    <div className='acivity-container'>
                                        <div className='like-content'>             
                                            <img className='like-image' src={userLikedImage} onClick={() => handleUnLikeBusiness(item.id)} />  
                                            {
                                                (item.total_likes != 1) ? (
                                                <p className='like-text'>{countFormatter(item.total_likes)} Likes</p>) : (
                                                <p className='like-text'>{countFormatter(item.total_likes)} Like</p>)
                                            }                                  
                                        </div>
                                        <div className='share-content' onClick={() => handleShare(item)}>
                                            <img className='share-image' src={shareGrey} />
                                            <p className='share-text'>Share</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))
                }
            </div>) : (
                <div className='no-liked-business'>{messageText}</div>
            )
            )
            }
            {
                (loaderPosition == 'bottom') && (
                <div>
                    <Loader loader={loaderPosition} />
                </div>)
            }
        </div>
    );
}

export default LikedBusinesses;
